/*
 *
 * GiftCardCart constants
 *
 */
import { utils, constants } from '../../devUtils';
import { validateRootPath } from '../HeaderContainer/constants';

export const DEFAULT_ACTION = '/GiftCardCart/DEFAULT_ACTION';
export const FETCH_CARTLIST_SUCCESS = '/GiftCardCart/FETCH_CARTLIST_SUCCESS';
export const DELETE_CART_ITEM_SUCCESS = '/GiftCardCart/DELETE_CART_ITEM_SUCCESS';
export const ADDTOCART_SUCCESS = '/GiftCardCart/ADDTOCART_SUCCESS';
export const FETCH_USER_ADDRESS = '/GiftCardCart/FETCH_USER_ADDRESS';
export const CREATE_CART_PAYLOAD = {
  skip_payable_validation: true,
  order:
  {
    zaggle_card_client_id: '',
    items:
      [
        // {
        //     product_variation_id: '',
        //     quantity: 0,
        //     shipping_address:
        //     {
        //         email: '',
        //         phone_numbers: '',
        //     },
        //     free_field_value: null
        // }
      ],
  },
};

export const MANDATORY_FIELDS = ['email', 'phone'];
export const CONSTRUCT_CART_LIST = (payload) => {
  const { items, shipping_address, zaggle_card_client_id, shipping_fee_cents } = payload;
  const cartList = items.map((item, i) => ({
    image: item.product.image && item.product.image.image.url,
    title: item.product.name,
    product_type: item.product.product_type,
    slug: item.product.slug,
    itemPrice: item.free_field_value || (item.variation.price_cents / 100),
    itemPriceAfterDisc: calicualteDiscount(item.product && item.product.discounts_percent.payment_gateway, item.free_field_value || (item.variation.price_cents / 100), zaggle_card_client_id),
    // amount: item.free_field_value * item.quantity || item.variation.name * item.quantity,
    quantity: item.quantity,
    key: i,
    email: shipping_address && shipping_address.email,
    Mobile: shipping_address && shipping_address.phone_numbers[0],
    Message: '',
    Delivery: CHECK_DELIVERY_TIME([{ ...item.variation, type: item.product.product_type }], item.quantity, item.delivery_period),
    product_variation_id: item.variation.id,
    client_id: zaggle_card_client_id,
    shipping_address: item.shipping_address,
    discountPersent: item.product && item.product.discounts_percent.payment_gateway ? item.product.discounts_percent.payment_gateway : 0,
    itemSubTotal: (item.free_field_value || (item.variation.price_cents / 100)) * item.quantity,
    itemSubTotalAfterDisc: calicualteDiscount(item.product && item.product.discounts_percent.payment_gateway, item.free_field_value * item.quantity || (item.variation.price_cents / 100) * item.quantity, zaggle_card_client_id),
    // discountedPrice: calicualteDiscount(item.product && item.product.discounts_percent.payment_gateway, item.free_field_value * item.quantity || (item.variation.price_cents / 100) * item.quantity, zaggle_card_client_id),
  }));
  let orderSummeryAmount = 0;
  let orderSummeryPrice = 0;
  let discountPersent = 0;
  // for (let i = 0; i < cartList.length; i++) {
  //   count += parseFloat(cartList[i].discountedPrice);
  // }
  cartList.forEach((element) => {
    orderSummeryAmount += parseFloat(element.itemSubTotalAfterDisc);
    orderSummeryPrice += element.itemSubTotal;
    discountPersent += element.discountPersent;
  });
  // let discountAmount = 0;
  let orderItemCount = 0;
  items.forEach((element) => {
    // discountAmount += parseFloat(element.free_field_value || element.variation.name);
    orderItemCount += element.quantity;
  });
  // for (let i = 0; i < items.length; i++) {
  //   discountAmount += parseFloat(items[i].free_field_value || items[i].variation.name);
  // }
  const orderObj = {
    orderSummeryAmount,
    discountPersent,
    shipping_fee_cents: shipping_fee_cents / 100,
    // beforeDiscount: discountAmount,
    orderSummeryPrice,
    orderItemCount,
    client_id: zaggle_card_client_id, // might be un-used
  };
  const finalObj = {
    cartList, orderObj, client_id: zaggle_card_client_id,
  };
  return finalObj;
};

function calicualteDiscount(discounts_percent, amount, client_id) {
  if (client_id === 'payment_gateway') {
    const value = (amount * discounts_percent) / 100;
    return parseFloat(amount) - value;
  }
  return amount;
}
export const CHECK_DELIVERY_TIME = (variations, quantity, delivery_period = 'Order will be fulfilled shortly') => {
  const result = utils.lodashFindIndex(variations, { vouchagram_enabled: true });
  if (result === -1) {
    if (variations && variations.length && variations[0].type === 'physical_voucher') {
      return updateVariations(variations, delivery_period);
    }
    variations.forEach((data) => {
      if (quantity > data.stock) {
        data = updateVariations([data], delivery_period);
      } else {
        data = updateVariations([data], delivery_period);
      }
    });
    return variations;
  }
  return updateVariations(variations, delivery_period);
};
function updateVariations(data, status) {
  data.forEach((element) => {
    element.delivery_value = status;
  });
  return data;
}

export const CHECK_ADDTOCART_ACTION_TYPE = (pathName, actionType = null) => {
  switch (pathName) {
    case constants.LINK_GIFTCARD_LIST:
    case constants.LINK_REDEEM_ZSC:
      return 'List - Add to Cart';
    case validateRootPath(pathName, constants.LINK_GIFTCARD_DETAILS):
      return (actionType === 'buyNow' ? 'Product - Buy Now' : 'Product - Add to Cart');

    default:
      return null;
  }
};



// WEBPACK FOOTER //
// client/containers/GiftCardCart/constants.js